<div class="columns is-marginless has-background-primary has-text-white">
    <div class='column is-11 is-size-4 has-text-weight-semibold'>
        {screenTitle}
    </div>
    <div class='column is-1'>
        <!-- <div class='button is-primary is-outlined is-inverted' on:click='set({gameEditorOpen: true})'>
            <span class='icon'>
                <i class='fas fa-info-circle'></i>
            </span>
        </div> -->
    </div>
</div>

<script>
    export default {
        data() {
            return {
                screenTitle: ''
            };
        }
    }
</script>
